import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { OrderPauseProvider } from "./context/OrderPauseContext";
import { WebSocketProvider } from "./context/WebSocketContext";
import App from "./App";
import "./styles/base.css";
import "./styles/variables.css";
import "./styles/components.css";
import "./styles/dashboard.css";
import "./styles/calendar.css";
import "./styles/orders.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <OrderPauseProvider>
      <WebSocketProvider>
        <App />
      </WebSocketProvider>
    </OrderPauseProvider>
  </BrowserRouter>
);
